import { DataTable } from '@/components/tables/data-table';
import { createAdvertiserColumns } from '@/components/tables/advertiser-columns';
import { useMemo } from 'react';

// Fake data for demo
const mockAdvertisers = [
  {
    id: 1,
    name: 'Acme Corp',
    address: '123 Main St',
    contactName: 'John Doe',
    contactEmail: 'john@acme.com',
    contactPhone: '555-0100',
    isActive: true,
    createdAt: '2024-01-15T10:00:00Z',
    updatedAt: '2024-01-15T10:00:00Z',
    campaignCount: 5,
  },
  {
    id: 2,
    name: 'Widget Inc',
    address: '456 Oak Ave',
    contactName: 'Jane Smith',
    contactEmail: 'jane@widget.com',
    contactPhone: '555-0200',
    isActive: true,
    createdAt: '2024-02-20T14:30:00Z',
    updatedAt: '2024-02-20T14:30:00Z',
    campaignCount: 3,
  },
  {
    id: 3,
    name: 'Demo LLC',
    address: '789 Pine Rd',
    contactName: 'Bob Johnson',
    contactEmail: 'bob@demo.com',
    contactPhone: '555-0300',
    isActive: true,
    createdAt: '2024-03-10T09:15:00Z',
    updatedAt: '2024-03-10T09:15:00Z',
    campaignCount: 8,
  },
];

export default function TableDemo() {
  const columns = useMemo(
    () => createAdvertiserColumns({
      onEdit: (advertiser) => alert(`Edit: ${advertiser.name}`),
      onDelete: (id) => Promise.resolve(alert(`Delete ID: ${id}`)),
      formatDate: (dateString) => new Date(dateString).toLocaleDateString(),
    }),
    []
  );

  return (
    <div className="container mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6">Sortable Table Demo</h1>
      <p className="mb-4 text-muted-foreground">
        Click any column header to sort. Click the "Columns" button to show/hide columns.
      </p>
      <DataTable
        columns={columns}
        data={mockAdvertisers}
        searchKey="name"
        searchPlaceholder="Search by name..."
        showColumnToggle={true}
        isLoading={false}
      />
    </div>
  );
}
